export interface AnalyticsEventData {
    name: string;
    element_name: string;
    element_id: string;
    action: string;
    category: string;
    data: Record<string, unknown>;
}

/**
 * Helper service for building and dispatching analytics events.
 * It creates custom tracking events and emits them through the DOM
 * so they can be captured by an analytics listener.
 */
export class AnalyticsService {
    /**
     * Builds a offer panel analytics event.
     * @param name string
     * @param elementId string
     * @param action string
     * @param category string
     * @param lang string
     * @returns AnalyticsEventData
     */
    static buildOfferPanelEvent(
        name: string,
        elementId: string,
        action: string,
        category: string,
        lang: string
    ): AnalyticsEventData {
        return {
            name: name,
            element_name: 'der-tm-offer-pannel',
            element_id: elementId,
            action: action,
            category: category,
            data: {
                position: 'roundtrip',
                language: lang,
            },
        };
    }

    /**
     * Dispatches a custom analytics event on the specified target.
     * @param target EventTarget
     * @param eventData AnalyticsEventData
     */
    static dispatch(target: EventTarget, eventData: AnalyticsEventData): void {
        target.dispatchEvent(
            new CustomEvent('der-analytics', {
                detail: eventData,
                bubbles: true,
                composed: true,
            })
        );
    }
}
